import { POSSIBLE } from "./utils.js";

import Anne from "./assets/characterPortraits/Anne.png";
import Bash from "./assets/characterPortraits/Bash.png";
import Billy from "./assets/characterPortraits/Billy.png";
import Cole from "./assets/characterPortraits/Cole.png";
import Diana from "./assets/characterPortraits/Diana.png";
import Gilbert from "./assets/characterPortraits/Gilbert.png";
import Jane from "./assets/characterPortraits/Jane.png";
import Jeannie from "./assets/characterPortraits/Jeannie.png";
import Jerry from "./assets/characterPortraits/Jerry.jpeg";
import Josephine from "./assets/characterPortraits/Josephine.png";
import Josie from "./assets/characterPortraits/Josie.png";
import Kakwet from "./assets/characterPortraits/Kakwet.png";
import Marilla from "./assets/characterPortraits/Marilla.png";
import Mary from "./assets/characterPortraits/Mary.jpeg";
import Matthew from "./assets/characterPortraits/Matthew.png";
import Minnie_May from "./assets/characterPortraits/Minnie_May.png";
import Miss_Stacy from "./assets/characterPortraits/Miss_Stacy.png";
import Mr_Barry from "./assets/characterPortraits/Mr_Barry.png";
import Mr_Phillips from "./assets/characterPortraits/Mr_Phillips.jpeg";
import Mrs_Barry from "./assets/characterPortraits/Mrs_Barry.png";
import Prissy from "./assets/characterPortraits/Prissy.png";
import Rachel from "./assets/characterPortraits/Rachel.png";
import Ruby from "./assets/characterPortraits/Ruby.png";
import Thomas from "./assets/characterPortraits/Thomas.png";
import Tillie from "./assets/characterPortraits/Tillie.png";
import Winifred from "./assets/characterPortraits/Winifred.png";

import ChoosingPerson from "./assets/choosingPerson.png";

export const choosingPerson = {
  name: "Choosing Person",
  imgSrc: ChoosingPerson
};

export const initialPeopleData = [
  { name: "Anne", imgSrc: Anne, status: POSSIBLE },
  { name: "Bash", imgSrc: Bash, status: POSSIBLE },
  { name: "Billy", imgSrc: Billy, status: POSSIBLE },
  { name: "Cole", imgSrc: Cole, status: POSSIBLE },
  { name: "Diana", imgSrc: Diana, status: POSSIBLE },
  { name: "Gilbert", imgSrc: Gilbert, status: POSSIBLE },
  { name: "Jane", imgSrc: Jane, status: POSSIBLE },
  { name: "Jeannie", imgSrc: Jeannie, status: POSSIBLE },
  { name: "Jerry", imgSrc: Jerry, status: POSSIBLE },
  { name: "Josephine", imgSrc: Josephine, status: POSSIBLE },
  { name: "Josie", imgSrc: Josie, status: POSSIBLE },
  { name: "Ka'kwet", imgSrc: Kakwet, status: POSSIBLE },
  { name: "Marilla", imgSrc: Marilla, status: POSSIBLE },
  { name: "Mary", imgSrc: Mary, status: POSSIBLE },
  { name: "Matthew", imgSrc: Matthew, status: POSSIBLE },
  { name: "Minnie May", imgSrc: Minnie_May, status: POSSIBLE },
  { name: "Miss Stacy", imgSrc: Miss_Stacy, status: POSSIBLE },
  { name: "Mr. Barry", imgSrc: Mr_Barry, status: POSSIBLE },
  { name: "Mr. Phillips", imgSrc: Mr_Phillips, status: POSSIBLE },
  { name: "Mrs. Barry", imgSrc: Mrs_Barry, status: POSSIBLE },
  { name: "Prissy", imgSrc: Prissy, status: POSSIBLE },
  { name: "Rachel", imgSrc: Rachel, status: POSSIBLE },
  { name: "Ruby", imgSrc: Ruby, status: POSSIBLE },
  { name: "Thomas", imgSrc: Thomas, status: POSSIBLE },
  { name: "Tillie", imgSrc: Tillie, status: POSSIBLE },
  { name: "Winifred", imgSrc: Winifred, status: POSSIBLE }
];
